import {cropCanvasByContentBounds} from "../imageEditor/functions";
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import _ from "lodash";
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

(function(fabric) {
fabric.PdfObject = fabric.util.createClass(fabric.Image, {
    type: 'PdfObject',

    file: null,
    fileWidth: null,
    fileHeight: null,

    initialize: function(file, options = {}) {
        this.callSuper('initialize', new Image(this.fileWidth || 200, this.fileHeight || 200), options);

        let app = this;
        if (file) {
            file2Json(file).then((r) => {
                app.file = r;
                app.loadInitialSize().then(()=> {
                    app.update();
                });
            });
        }
    },

    debouncedModified: _.debounce((obj) => {
        obj.update();
    }, 500),

    _set: function (key, value) {
        this.callSuper('_set', key, value); //todo find a way to disable canvas:fire on this method

        switch(key) {
            case 'scaleX':
            case 'scaleY':
                this.debouncedModified(this);
                break;
            default:
        }
    },

    update: async function () {
        let app = this;
        let dataUrl = await this.loadPdf(this.file);

        let img = new Image();
        let promise = onload2promise(img);
        img.src = dataUrl;

        await promise;

        app.setElement(img);

        let max = Math.max(this.scaleX, this.scaleY);
        this.scaleX /= max;
        this.scaleY /= max;

        if (!this.canvas) return;
        this.canvas.fire('object:modified', {target: this, dieCut_slow: true});
        this.canvas.requestRenderAll();
    },

    loadInitialSize: async function() {
        let dataUrl = await this.loadPdf(this.file, 1);
        let img = new Image();

        let promise = onload2promise(img);
        img.src = dataUrl;
        await promise;

        this.fileWidth = img.width;
        this.fileHeight = img.height;
    },

    loadPdf: async function(file, scale = null) {
        let loadingTask = pdfjsLib.getDocument(convertDataURIToBinary(file.fileContent));
        let pdf = await loadingTask.promise;
        let page = await pdf.getPage(1);

        let max = Math.max(this.width*this.scaleX/this.fileWidth, this.height*this.scaleY/this.fileHeight)
        scale = scale || max;

        let viewport = page.getViewport({ scale: scale });
        let canvas = document.createElement('canvas');
        let context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        context.fillStyle = "rgba(0,0,0,0)";
        context.fillRect(0, 0, canvas.width, canvas.height);

        let renderContext = {
            canvasContext: context,
            viewport: viewport,
            background: 'rgba(0,0,0,0)',
        };

        let renderTask = page.render(renderContext);
        await renderTask.promise;

        canvas = cropCanvasByContentBounds(canvas);
        return canvas.toDataURL("image/png", 1.0);
    },

    toObject: function (propertiesToInclude) {
        return this.callSuper('toObject', ['fileWidth', 'fileHeight', 'file'].concat(propertiesToInclude));
    },
});

fabric.PdfObject.fromObject = function (object, callback) {
    let pdfObject = new fabric.PdfObject();

    Object.assign(pdfObject, object);

    pdfObject.loadInitialSize().then(()=> {
        pdfObject.update();
    });

    if (callback) {
        callback(pdfObject);
    }
}

})(typeof fabric !== 'undefined' ? fabric : require('fabric').fabric);

function onload2promise(obj){
    return new Promise((resolve, reject) => {
        obj.onload = () => resolve(obj);
        obj.onerror = reject;
    });
}

async function file2Json(file) {
    if (!file) {
        return;
    }

    const fileName = file.name;
    try {
        const fileContent = await readFile(file);
        return {
            fileName: file.name,
            fileContent: fileContent,
        }
    } catch(error) {
        console.log(error);
    }
}

function readFile(file) {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        fileReader.onerror = () => {
            reject(fileReader.error);
        };
        fileReader.readAsDataURL(file);
    });
}

function convertDataURIToBinary(dataURI) {
    let BASE64_MARKER = ';base64,';
    let base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    let base64 = dataURI.substring(base64Index);
    let raw = window.atob(base64);
    let rawLength = raw.length;
    let array = new Uint8Array(new ArrayBuffer(rawLength));

    for(let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
    }
    return array;
}
